(function() {
  const initChooseStyle = () => {
    // 寻找页面上所有未初始化的款式选择组件
    const components = document.querySelectorAll('.t4s-pr-choose__style:not([data-initialized])');
    
    components.forEach(component => {
      component.dataset.initialized = 'true';

      const wrap = component.querySelector('.t4s-pr-choose__wrap');
      const items = component.querySelectorAll('.t4s-pr-choose__item');

      if (window.innerWidth >= 768 && wrap && items.length > 0) {
        let rowHeight = 88; // 默认值

        const calculateAndSetupScroll = () => {
          const firstItem = items[0];
          let itemsPerRow = 0;
          for (let i = 0; i < items.length; i++) {
            if (items[i].offsetTop === firstItem.offsetTop) {
              itemsPerRow++;
            } else {
              break;
            }
          }

          if (itemsPerRow > 0 && items.length > itemsPerRow * 2) {
            // 精确计算单行高度 (包含间距)
            rowHeight = items[itemsPerRow].offsetTop - items[0].offsetTop;
            // 设置容器高度为 2 行图片的高度 + 1 行间距
            const containerHeight = (items[0].offsetHeight * 2) + (rowHeight - items[0].offsetHeight);
            wrap.style.setProperty('--choose-style-height', `${containerHeight + 1}px`); // +1px 容错防止亚像素滚动条
          } else {
            wrap.style.removeProperty('--choose-style-height');
          }
        };

        // 延迟计算确保图片和布局已渲染
        setTimeout(() => {
          calculateAndSetupScroll();
          // 初始触发一次懒加载检查，确保首屏（包括可能的第二行）加载
          if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
          }
        }, 300);

        // 修复 Mac/Safari 上的懒加载问题：当内部容器滚动时，触发 lazysizes 检查
        wrap.addEventListener('scroll', () => {
          if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
          }
        }, { passive: true });

        // --- 解决 Mac 上的“同步滚动”问题 ---
        // 我们通过监听 wheel 事件，在容器内部还有滚动空间时拦截它，防止外层页面同时滚动
        let isScrolling = false;
        wrap.addEventListener('wheel', (e) => {
          if (window.innerWidth < 768) return;

          const scrollTop = wrap.scrollTop;
          const scrollHeight = wrap.scrollHeight;
          const clientHeight = wrap.clientHeight;
          const deltaY = e.deltaY;

          // 如果容器本身不可滚动，则不做处理
          if (scrollHeight <= clientHeight) return;

          // 边界判断（增加容错值以适配 Mac 的弹性滚动）
          const tolerance = 2;
          const isAtTop = scrollTop <= tolerance;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - tolerance;

          // 核心逻辑：
          // 1. 如果向上滚动且已到达顶部，不拦截，让页面滚动（滚动链）
          // 2. 如果向下滚动且已到达底部，不拦截，让页面滚动（滚动链）
          if (deltaY < 0 && isAtTop) return;
          if (deltaY > 0 && isAtBottom) return;

          // 3. 只要还在容器内部滚动空间内，就强制拦截默认滚动，解决“同步滚动”
          e.preventDefault();

          // 4. 执行组件特有的分页滚动逻辑
          if (isScrolling) return;
          const direction = deltaY > 0 ? 1 : -1;
          const scrollAmount = rowHeight * 2; 

          isScrolling = true;
          wrap.scrollBy({
            top: direction * scrollAmount,
            behavior: 'smooth'
          });

          // 冷却时间，针对 Mac 高频事件做平衡处理
          setTimeout(() => { isScrolling = false; }, 400);
        }, { passive: false });

        window.addEventListener('resize', calculateAndSetupScroll);
      }
    });
  };

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChooseStyle);
  } else {
    initChooseStyle();
  }

  // 暴露给全局以便在 AJAX 加载内容后重新调用（如款式切换后）
  window.initT4SChooseStyle = initChooseStyle;
})();
